// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Link from "../Link.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function TraitInfoCard$Inner(Props) {
  var traitId = Props.traitId;
  var suffixOpt = Props.suffix;
  var suffix = suffixOpt !== undefined ? suffixOpt : "";
  var set = TftSet.use(undefined);
  var units = Sd.getTraitUnits(traitId, set);
  var traitsT = Translation.useT(/* Traits */2);
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement(Link.make, {
                  route: {
                    TAG: /* Info */6,
                    _0: {
                      TAG: /* Trait */2,
                      _0: set,
                      _1: traitId
                    }
                  },
                  children: React.createElement("div", {
                        className: "flex items-center gap-[3px]"
                      }, React.createElement(TraitImage.PlainIcon.make, {
                            traitId: traitId,
                            size: 24
                          }), React.createElement("h3", {
                            className: "inline-block text-xl font-montserrat font-medium"
                          }, traitsT(traitId)))
                }), React.createElement("div", {
                  className: "py-3 text-sm leading-tight"
                }, React.createElement(RitoDescription2.make, {
                      desc: traitsT(traitId + suffix + "_desc")
                    })), React.createElement("div", {
                  className: "flex pt-2 gap-[10px] flex-wrap"
                }, Belt_Array.map(units, (function (unitId) {
                        return React.createElement(UnitTooltip.make, {
                                    unit: unitId,
                                    children: React.createElement(UnitImage.make, {
                                          unitId: unitId,
                                          size: 40
                                        }),
                                    key: unitId
                                  });
                      }))));
}

var Inner = {
  make: TraitInfoCard$Inner
};

function TraitInfoCard(Props) {
  var traitId = Props.traitId;
  var suffixOpt = Props.suffix;
  var suffix = suffixOpt !== undefined ? suffixOpt : "";
  var set = TftSet.use(undefined);
  Belt_Option.getExn(Dict.get(Data.traits(set), traitId));
  var units = Sd.getTraitUnits(traitId, set);
  var traitsT = Translation.useT(/* Traits */2);
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement(Link.make, {
                  route: {
                    TAG: /* Info */6,
                    _0: {
                      TAG: /* Trait */2,
                      _0: set,
                      _1: traitId
                    }
                  },
                  children: React.createElement("div", {
                        className: "flex items-center gap-[3px]"
                      }, React.createElement(TraitImage.PlainIcon.make, {
                            traitId: traitId,
                            size: 24
                          }), React.createElement("h3", {
                            className: "inline-block text-xl font-montserrat font-medium"
                          }, traitsT(traitId)))
                }), React.createElement("div", {
                  className: "py-3 text-sm leading-tight"
                }, React.createElement(RitoDescription2.make, {
                      desc: traitsT(traitId + suffix + "_desc")
                    })), React.createElement("div", {
                  className: "flex pt-2 gap-[10px] flex-wrap"
                }, Belt_Array.map(units, (function (unitId) {
                        return React.createElement(UnitTooltip.make, {
                                    unit: unitId,
                                    children: React.createElement(UnitImage.make, {
                                          unitId: unitId,
                                          size: 40
                                        }),
                                    key: unitId
                                  });
                      }))));
}

var make = TraitInfoCard;

export {
  Inner ,
  make ,
  
}
/* Sd Not a pure module */
